class CollectionCarouselSection {
  constructor(root) {
    this.root = root;
    this.track = root.querySelector('.collection-carousel-section__track');
    this.prevBtn = root.querySelector('.collection-carousel-section__arrow--prev');
    this.nextBtn = root.querySelector('.collection-carousel-section__arrow--next');
    this.dotsWrap = root.querySelector('.collection-carousel-section__dots');
    this.autoplay = root.dataset.autoplay === 'true';
    this.autoplaySpeed = parseInt(root.dataset.autoplaySpeed, 10) || 5000;
    this.timer = null;
    this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (!this.track) return;

    this.buildDots();
    this.bindEvents();
    if (this.autoplay && !this.reducedMotion) this.startAutoplay();
  }

  get slides() {
    return Array.from(this.track.children);
  }

  slideWidth() {
    const slide = this.slides[0];
    if (!slide) return 0;
    const style = window.getComputedStyle(this.track);
    const gap = parseFloat(style.columnGap || style.gap || '0');
    return slide.getBoundingClientRect().width + gap;
  }

  scrollByAmount(direction) {
    this.track.scrollBy({ left: direction * this.slideWidth(), behavior: 'smooth' });
  }

  buildDots() {
    if (!this.dotsWrap) return;
    this.dotsWrap.innerHTML = '';
    this.slides.forEach((_, index) => {
      const dot = document.createElement('button');
      dot.type = 'button';
      dot.setAttribute('aria-label', `Ir para o slide ${index + 1}`);
      dot.addEventListener('click', () => {
        this.track.scrollTo({ left: index * this.slideWidth(), behavior: 'smooth' });
      });
      this.dotsWrap.appendChild(dot);
    });
    this.updateDots();
  }

  updateDots() {
    if (!this.dotsWrap) return;
    const index = Math.round(this.track.scrollLeft / (this.slideWidth() || 1));
    Array.from(this.dotsWrap.children).forEach((dot, i) => {
      dot.setAttribute('aria-current', i === index ? 'true' : 'false');
    });
  }

  bindEvents() {
    if (this.prevBtn) this.prevBtn.addEventListener('click', () => this.scrollByAmount(-1));
    if (this.nextBtn) this.nextBtn.addEventListener('click', () => this.scrollByAmount(1));

    this.track.addEventListener('scroll', () => this.updateDots());

    ['mouseenter', 'focusin', 'touchstart'].forEach((evt) => {
      this.root.addEventListener(evt, () => this.stopAutoplay(), { passive: true });
    });
    ['mouseleave', 'focusout'].forEach((evt) => {
      this.root.addEventListener(evt, () => {
        if (this.autoplay && !this.reducedMotion) this.startAutoplay();
      });
    });

    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) this.stopAutoplay();
          else if (this.autoplay && !this.reducedMotion) this.startAutoplay();
        });
      }, { threshold: 0.2 });
      observer.observe(this.root);
    }
  }

  startAutoplay() {
    this.stopAutoplay();
    this.timer = setInterval(() => {
      const atEnd = this.track.scrollLeft + this.track.clientWidth >= this.track.scrollWidth - 2;
      if (atEnd) {
        this.track.scrollTo({ left: 0, behavior: 'smooth' });
      } else {
        this.scrollByAmount(1);
      }
    }, this.autoplaySpeed);
  }

  stopAutoplay() {
    if (this.timer) clearInterval(this.timer);
    this.timer = null;
  }
}

function initCollectionCarousels(context) {
  (context || document).querySelectorAll('.collection-carousel-section').forEach((section) => {
    if (section.dataset.carouselInitialized) return;
    section.dataset.carouselInitialized = 'true';
    new CollectionCarouselSection(section);
  });
}

document.addEventListener('DOMContentLoaded', () => initCollectionCarousels());

// Suporte ao editor de temas (Shopify Theme Editor): reinicializa quando a secção é carregada/atualizada
document.addEventListener('shopify:section:load', (event) => initCollectionCarousels(event.target));
